import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  text-transform: capitalize;\n  font-family: $thin-font;\n  text-align: center;\n  display: block;\n  ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #2c2c2c;\n  opacity: 0;\n  transition: 0.3s;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      width: 10px;\n      height: 7px;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      width: 11px;\n      height: 8px;\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      width: 30px;\n      height: 30px;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      width: 46px;\n      height: 46px;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    width: 100px;\n    height: 120px;\n    margin-bottom: 13px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    width: 130px;\n    height: 170px;\n    margin-bottom: 14px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 186px;\n  height: 240px;\n  margin-bottom: 20px;\n  ", "\n  ", "\n  background-position: center;\n  background-size: cover;\n  position: relative;\n  &::before {\n    content: \"\";\n    font-size: 30px;\n    border-radius: 50%;\n    width: 66px;\n    height: 66px;\n    ", "\n    ", "\n    z-index: 1;\n    opacity: 0;\n    bottom: 50%;\n    right: 50%;\n    position: absolute;\n    transform: translate(50%, 50%);\n  }\n  &::after {\n    content: \"\";\n    display: block;\n    width: 15px;\n    height: 11px;\n    ", "\n    ", "\n    background-image: url(\"../../../images/check.svg\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    bottom: 50%;\n    right: 50%;\n    position: absolute;\n    transform: translate(50%, 50%);\n    z-index: 2;\n    opacity: 0;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 5px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 8px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 10px;\n  transition: color 0.6s;\n  cursor: pointer;\n  ", "\n  ", "\n  &:first-of-type {\n    margin-left: 0;\n  }\n  &:last-of-type {\n    margin-right: 0;\n  }\n  &:hover {\n    color: #c34c3e;\n    .category-item__image {\n      &-overlay {\n        opacity: 0.6;\n      }\n      &::before {\n        opacity: 0.2;\n        border: 2px solid #ffffff;\n      }\n      &::after {\n        opacity: 0.2;\n      }\n    }\n  }\n  &.active {\n    &__image {\n      &-overlay {\n        opacity: 0.6;\n      }\n      &::before {\n        opacity: 1;\n        background-color: #ca9c66;\n      }\n      &::after {\n        opacity: 1;\n      }\n    }\n    .category-item {\n      &__image {\n        &-overlay {\n          opacity: 0.6;\n        }\n        &::before {\n          opacity: 1;\n          background-color: #ca9c66;\n        }\n        &::after {\n          opacity: 1;\n        }\n      }\n      &__title {\n        color: #c34c3e;\n      }\n    }\n    &:hover {\n      .category-item__image::before {\n        border: none;\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: auto;\n  overflow-x: auto;\n  overflow-y: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject());
export var CategoryItem = styled.div(_templateObject2(), media.xxLargeScreen(_templateObject3()), media.mediumScreen(_templateObject4()));
export var CategoryItemImage = styled.div(_templateObject5(), media.xxLargeScreen(_templateObject6()), media.mediumScreen(_templateObject7()), media.xxLargeScreen(_templateObject8()), media.mediumScreen(_templateObject9()), media.xxLargeScreen(_templateObject10()), media.mediumScreen(_templateObject11()));
export var CategoryItemImageOverlay = styled.div(_templateObject12());
export var CategoryItemTitle = styled.div(_templateObject13(), media.xxLargeScreen(_templateObject14()));